<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M18 6.65332L6 18.6533M18 18.6533L6 6.65332"
      :stroke="color || '#8B8B8B'"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  props: ["color"],
};
</script>
